import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import { useState } from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Link } from "react-router-dom";
import useSaveDocument from "../../../hooks/useSaveDocument";
import Swal from "sweetalert2";

import { patchNewSheet } from "../../../utils/variables";

function AddNewSheet({
  sheetArray,
  setSheetArray,
  selectedSheet,
  setSelectedSheet,
}) {
  const [currentSheet, setCurrentSheet] = useState(selectedSheet);
  const { newDocument, saveDocument } = useSaveDocument();

  const handleAddNewSheet = async () => {
    await saveDocument();

    const { id } = await newDocument();
    // setSelectedSheet(currentSheet + 1);
    setCurrentSheet(currentSheet + 1);
    setSheetArray([...sheetArray, { page: currentSheet + 1, id }]);

    await patchNewSheet([...sheetArray, { page: currentSheet + 1, id }]);
  };

  return (
    <Stack spacing={1} direction="row">
      <div
        style={{
          width: "80%",
          overflow: "auto",
          display: "flex",
          overflowY: "hidden",
          padding: "20px",
        }}
        id="scrollbar"
      >
        {sheetArray.map((sheet) => {
          return (
            <Button
              component={Link}
              to={"/file/" + sheet.id}
              variant={selectedSheet === sheet.page ? "contained" : "outlined"}
              size="medium"
              sx={{
                marginRight: "10px",
                width: "200px",
                borderRadius: ".3rem",
                textTransform: "capitalize",
              }}
              autocapitalize="off"
              onClick={() => {
                setSelectedSheet(sheet.page);
              }}
            >
              Sheet {sheet.page}
            </Button>
          );
        })}
      </div>
      <IconButton
        edge="start"
        onClick={handleAddNewSheet}
        aria-label="close"
        className="icon_button"
        style={{
          fontSize: "15px",
          float: "right",
          textDecoration: "none",
          justifyContent: "space-between",
        }}
      >
        <AddCircleOutlineIcon /> Add New Sheet
      </IconButton>
      {/* <Button variant="outlined">Sheet</Button> */}
    </Stack>
  );
}

export default AddNewSheet;
